import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthService } from './core/services/auth/auth.service';
import { LoginComponent } from './feature/login/login.component';
import { RouterOutlet } from '@angular/router';
import { I18n, NgtThemeService, ThemeSetting } from '@corporate/ng-tebis-base-components';
import { UserServiceRds } from './core/services/user/user.service.rds';
import { OnboardingTourService } from './feature/onboarding-tour/onboarding-tour.service';
import { OnboardingTourComponent } from './feature/onboarding-tour/onboarding-tour.component';
import { MaintenanceMessageComponent } from './feature/maintenance-message/maintenance-message.component';
import { ServerStatusService } from './core/services/server-status.service';

@Component({
  selector: 'app-root',
  imports: [
    LoginComponent,
    RouterOutlet,
    OnboardingTourComponent,
    MaintenanceMessageComponent,
  ],
  templateUrl: 'app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    OnboardingTourService,
  ],
})
export class AppComponent {
  authService = inject(AuthService);
  serverStatusService = inject(ServerStatusService);

  // load user service so current user is added to the database when user info is loaded
  userService = inject(UserServiceRds);

  onboarding = inject(OnboardingTourService);

  title="tebitasks"

  constructor() {
    inject<I18n>(I18n).setLang('de');
    inject(NgtThemeService).themeSetting.set(ThemeSetting.LIGHT);

    this.onboarding.setTour('app-root', [
      {
        title: 'help:navigationTitle',
        text: 'help:clickOnTheGoalsTab',
        position: 'right',
        query: '#goalsNavButton',
        skipWhenQuerriedClicked: true,
        hideNextButton: false,
      },
      {
        title: 'help:configurationTitle',
        text: 'help:configurationText',
        position: 'left',
        query: '#okrTreeColumnCustomization',
      },
      {
        title: 'help:furtherHelpTitle',
        text: 'help:furtherHelpText',
        position: 'right',
        query: '#mainMenuHelpButton',
      },
    ]);
    this.onboarding.startTour();
  }
}
